/**
 * External API URLs and third-party service endpoints
 */

// HumanAtlas FTU Illustrations API
export const FTU_ILLUSTRATIONS_API_URL = "https://apps.humanatlas.io/api/v1/ftu-illustrations";

// HumanAtlas CDN for FTU illustration data
export const FTU_ILLUSTRATIONS_JSONLD_URL =
  "https://cdn.humanatlas.io/digital-objects/graph/2d-ftu-illustrations/latest/assets/2d-ftu-illustrations.jsonld";

// Default FTU illustration selection
export const DEFAULT_FTU_ILLUSTRATION_URL =
  "https://purl.humanatlas.io/2d-ftu/lung-pulmonary-alveolus";
